module.exports = __webpack_public_path__ + "img/20191128170100471.58ed4baa.jpg";